import React, { useState, useEffect } from "react";
import {
  Page,
  Tabs,
  Tab,
  Icon,
  Link,
  Fab,
  Toolbar,
  Button,
  f7,
} from "framework7-react";
import axios from "axios";
import { API_BASE_URL, API_AUTH, IMG_URL } from "./../globals";
const eatBidsLogo = require("./../images/logo/eatbids-logo.png");

const TabBid = () => {
  const [data, setData] = useState([]);
  const [auth, setAuth] = useState(localStorage.getItem("auth"));
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const id = localStorage.getItem("id");
    const token = localStorage.getItem("token");
    const headers = {
      Authorization: "Basic " + API_AUTH,
    };
    axios
      .post(API_BASE_URL + "custauth", { id, token }, { headers })
      .then((response) => {
        console.log(response.data);
        if (response.data.status === "success") {
          localStorage.setItem("auth", true);
          setAuth(true);
          // setTimeout(() => {
          //   setIsLoading(false); // API call is complete
          //   f7.views.main.router.navigate('/main/');
          // }, 1000);
        } else {
          localStorage.setItem("auth", false);
          setAuth(false);
          // setTimeout(() => {
          //   setIsLoading(false); // API call is complete
          //   // f7.views.main.router.navigate('/login/');
          // }, 1000);
        }
      })
      .catch((error) => {
        setAuth(false);
        // setTimeout(() => {
        //   setIsLoading(false); // API call is complete even in case of an error
        //   console.log(error);
        //   // f7.views.main.router.navigate('/login/');
        // }, 1000);
      });
  });
  useEffect(() => {
    axios
      .get(API_BASE_URL + "eventbycust/id/" + localStorage.getItem("id"), {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
        params: {
          // cust_id: localStorage.getItem('id'),
          limits: 100,
          event_status: 1,
        },
      })
      .then((response) => {
        setData(response.data.data);
      })
      .catch((error) => console.log(error));
  }, []);

  const [pastdata, setPastData] = useState([]);
  useEffect(() => {
    axios
      .get(API_BASE_URL + "resteventview", {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
        params: {
          cust_id: localStorage.getItem("id"),
          limits: 100,
          order_status: 2,
        },
      })
      .then((response) => {
        setPastData(response.data);
      })
      .catch((error) => console.log(error));
    console.log(setPastData);
  }, []);
  const [acceptData, setAptData] = useState([]);
  useEffect(() => {
    axios
      .get(API_BASE_URL + "custacceptorder", {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
        params: {
          cust_id: localStorage.getItem("id"),
          limits: 100,
          order_status: 3,
        },
      })
      .then((response) => {
        setAptData(response.data);
      })
      .catch((error) => console.log(error));
  }, []);

  const redLogin = () => {
    localStorage.clear();
    f7.views.main.router.navigate("/login/");
  };

  const divStyle = {
    backgroundImage: `url("${eatBidsLogo}")`, // Replace with the actual path to your image
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover", // Adjust as needed (e.g., 'contain', '100% 100%', etc.)
    backgroundPosition: "top left", // Positions the image at the top-left corner
    marginTop: "-30px",
    marginBottom: "-20px",
    marginLeft: "10px",
    width: "106px", // Set the width and height to fill the viewport
    height: "40px",
  };

  return (
    <Page className="bg-white">
      {auth ? (
        <Fab position="right-bottom" slot="fixed" href="/addevent/">
          <Icon
            ios="material:add"
            aurora="material:add"
            md="material:add"
          ></Icon>
        </Fab>
      ) : (
        ""
      )}
      <div className="container container-table ">
        <div className="row vertical-center-row col-sm col-md-offset-12">
          {/* <div className="section full mt-2">
              <div className="appHeader">
                <div className='pageTitle'><h2>Event</h2></div>
              </div>        
            </div> */}
          <header className="section-t-space p-3">
            <div className="container-lg custom-container p-0">
              <div className="header-panel p-0">
                <h2 className="mt-0">Event</h2>
                <Link href="#" className="mt-0"></Link>
                <Link href="/eventordersearch/" className="mt-0">
                  <Icon
                    ios="material:search"
                    aurora="material:search"
                    md="material:search"
                    className="theme-dark"
                    size={22}
                  ></Icon>
                </Link>
              </div>
              <div className="custom-logo d-none d-md-block" style={divStyle} />
            </div>
          </header>

          {/* <section className="search-section section-t-space" style={{padding:'46px 0'}}>
              <div className='extraHeader' style={{background:'#F0F0F0'}}>
                <Segmented tag="p" strong style={{width:'100%',}} className='mt-0'>
                  <Button tabLink="#bid-1" tabLinkActive>Current</Button>
                  <Button tabLink="#bid-2">Past</Button>          
                </Segmented>
              </div>        
            </section> */}
          <div className="extraHeader p-0 bg-light d-flex justify-content-center">
            <Toolbar tabbar top className="bg-light" noShadow>
              <Link tabLink="#bid-1" tabLinkActive>
                CURRENT
              </Link>
              <Link tabLink="#bid-2">REVIEW</Link>
              <Link tabLink="#bid-3">ACCEPTED</Link>
            </Toolbar>
          </div>
          <Tabs style={{ padding: "102px 12px" }}>
            <Tab id="bid-1" tabActive className="bg-light">
              {auth ? (
                <section className="section-t-space bg-white mt-0">
                  <div className="container p-0">
                    <div className="row gy-3 ">
                      {data.length > 0 ? (
                        data.map((item) => (
                          <div className="bid-web-view-div ">
                            <a href={`/eventdetail/${item.id}/`}>
                              <div className="vertical-product-box order-box">
                                <div className="vertical-box-img">
                                  <img
                                    className="img-fluid img"
                                    src={require("./../images/events.jpg")}
                                    alt="vp1"
                                  />
                                </div>
                                <div className="vertical-box-details">
                                  <div className="vertical-box-head">
                                    <div className="restaurant">
                                      <h5 className="dark-text">
                                        {item.event_name}
                                      </h5>
                                      <h5
                                        className={
                                          item.order_status == 5
                                            ? "text-danger"
                                            : "text-success"
                                        }
                                      >
                                        {item.order_status_text}{" "}
                                      </h5>
                                    </div>
                                    {item.delivery_type == "Delivery" ? (
                                      <h6 className="food-items mb-2">
                                        <Icon
                                          ios="material:location_on"
                                          aurora="material:location_on"
                                          md="material:location_on"
                                          className="text-success text-3"
                                        />{" "}
                                        {item.add_lin_1} {item.add_lin_2}{" "}
                                        {item.city} {item.state} {item.zip_code}
                                      </h6>
                                    ) : (
                                      <h6 className="food-items mb-2"></h6>
                                    )}
                                  </div>
                                  <div className="reorder">
                                    <h6 className="rating-star">
                                      <ul className="timing">
                                        <li>
                                          <Icon
                                            ios="material:groups"
                                            aurora="material:groups"
                                            md="material:groups"
                                            className="text-muted text-4"
                                          />{" "}
                                          {item.event_adult_size +
                                            item.event_kids_size}{" "}
                                        </li>
                                        <li>
                                          <Icon
                                            ios="material:event"
                                            aurora="material:event"
                                            md="material:event"
                                            className="text-muted text-4"
                                          />{" "}
                                          {item.event_date}
                                        </li>
                                        {/* <li className="text-success"> {item.order_status}</li> */}
                                        {/* <li><a fill small className="" href={`/edit_event/${item.id}/`}>  Edit </a></li> */}
                                      </ul>
                                    </h6>
                                  </div>
                                </div>
                              </div>
                            </a>
                          </div>
                        ))
                      ) : (
                        <div className="custom-container">
                          <div className="empty-tab">
                            <h2>No Current Event Found!!</h2>
                            <h5 className="mt-3">
                              You have currently no events.
                            </h5>
                            <a
                              href="/addevent/"
                              className="btn btn-success w-100 mt-5"
                              role="button"
                            >
                              Request a Bid
                            </a>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </section>
              ) : (
                <div className="custom-container mt-5">
                  <div className="empty-tab">
                    <h3 className="mt-5">Have eatbids account?</h3>
                    <a
                      onClick={redLogin}
                      className="btn theme-btn w-100 mt-4"
                      role="button"
                    >
                      Log in
                    </a>
                  </div>
                  <div class="division">
                    <span>OR</span>
                  </div>
                  <div className="empty-tab">
                    <p className="btn gray-btn mt-3 text-3 w-100">
                      {" "}
                      You don't have an account?{" "}
                      <a href="/register/" className="text-black">
                        Sign up
                      </a>
                    </p>
                  </div>
                </div>
              )}
            </Tab>
            <Tab id="bid-2">
              {auth ? (
                <section className="section-t-space bg-white mt-0">
                  <div className="container p-0">
                    <div className="row gy-3">
                      {pastdata.length > 0 ? (
                        pastdata.map((item) => (
                          <div className="bid-web-view-div">
                            <div className="custom-container p-0">
                              <a
                                href={`/eventrestdetails/${item.event_id}/${item.rest_id}`}
                              >
                                <div className="vertical-product-box order-box">
                                  <div className="vertical-box-img">
                                    {item.rest_img ? (
                                      <img
                                        className="img-fluid img"
                                        src={`${IMG_URL}${item.rest_img}`}
                                        alt="vp1"
                                      />
                                    ) : (
                                      <img
                                        className="img-fluid img"
                                        src={require("./../images/no-image.png")}
                                        alt="vp1"
                                      />
                                    )}
                                  </div>
                                  <div className="vertical-box-details">
                                    <div className="vertical-box-head">
                                      <div className="restaurant">
                                        <h5 className="dark-text">
                                          {item.rest_name}
                                        </h5>
                                        <h5 className="text-success">
                                          {item.event_status}
                                        </h5>
                                      </div>
                                      <h6 className="food-items mb-2">
                                        <Icon
                                          ios="material:location_on"
                                          aurora="material:location_on"
                                          md="material:location_on"
                                          className="text-success text-3"
                                        />
                                        Event Name : {item.event_name}
                                      </h6>
                                    </div>
                                    <div className="reorder">
                                      <h6 className="rating-star">
                                        <ul className="timing">
                                          <li>
                                            <Icon
                                              ios="material:groups"
                                              aurora="material:groups"
                                              md="material:groups"
                                              className="text-muted text-4"
                                            />{" "}
                                            {item.event_adult_size +
                                              item.event_kids_size}{" "}
                                          </li>
                                          <li>
                                            <Icon
                                              ios="material:event"
                                              aurora="material:event"
                                              md="material:event"
                                              className="text-muted text-4"
                                            />{" "}
                                            {item.event_date}
                                          </li>
                                          {/* <li className="text-success"> {item.event_status}</li> */}
                                        </ul>
                                      </h6>
                                    </div>
                                  </div>
                                </div>
                              </a>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="custom-container">
                          <div className="empty-tab">
                            <h2>No Event Found!!</h2>
                            <h5 className="mt-3">
                              You have currently no events.
                            </h5>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </section>
              ) : (
                <div className="custom-container mt-5">
                  <div className="empty-tab">
                    <h3 className="mt-5">Have eatbids account?</h3>
                    <a
                      onClick={redLogin}
                      className="btn theme-btn w-100 mt-4"
                      role="button"
                    >
                      Log in
                    </a>
                  </div>
                  <div class="division">
                    <span>OR</span>
                  </div>
                  <div className="empty-tab">
                    <p className="btn gray-btn mt-3 text-3 w-100">
                      {" "}
                      You don't have an account?{" "}
                      <a href="/register/" className="text-black">
                        Sign up
                      </a>
                    </p>
                  </div>
                </div>
              )}
            </Tab>
            <Tab id="bid-3">
              {auth ? (
                <section className="section-t-space bg-white mt-0">
                  <div className="custom-container p-0">
                    <div className="container p-0">
                      <div className="row gy-3">
                        {acceptData.length > 0 ? (
                          acceptData.map((item) => (
                            <div className="bid-web-view-div">
                              <div className="custom-container p-0 ">
                                <a
                                  href={
                                    item.is_event === 1
                                      ? `/eventacceptdetails/${item.event_id}/${item.rest_id}`
                                      : `/order_details/${item.order_id}/`
                                  }
                                >
                                  <div className="vertical-product-box order-box">
                                    <div className="vertical-box-img">
                                      {item.rest_img ? (
                                        <img
                                          className="img-fluid img"
                                          src={`${IMG_URL}${item.rest_img}`}
                                          alt="vp1"
                                        />
                                      ) : (
                                        <img
                                          className="img-fluid img"
                                          src={require("./../images/no-image.png")}
                                          alt="vp1"
                                        />
                                      )}
                                    </div>
                                    <div className="vertical-box-details">
                                      <div className="vertical-box-head">
                                        <div className="restaurant">
                                          <h5 className="dark-text">
                                            {item.rest_name}
                                          </h5>
                                          <h5 className="text-success">
                                            {item.event_status}
                                          </h5>
                                        </div>
                                        <h6 className="food-items mb-2">
                                          <Icon
                                            ios="material:location_on"
                                            aurora="material:location_on"
                                            md="material:location_on"
                                            className="text-success text-3"
                                          />
                                          Event Name : {item.event_name}
                                        </h6>
                                      </div>
                                      <div className="reorder">
                                        <h6 className="rating-star">
                                          <ul className="timing">
                                            <li>
                                              <Icon
                                                ios="material:groups"
                                                aurora="material:groups"
                                                md="material:groups"
                                                className="text-muted text-4"
                                              />{" "}
                                              {item.event_adult_size +
                                                item.event_kids_size}{" "}
                                            </li>
                                            <li>
                                              <Icon
                                                ios="material:event"
                                                aurora="material:event"
                                                md="material:event"
                                                className="text-muted text-4"
                                              />{" "}
                                              {item.event_date}
                                            </li>
                                            {/* <li className="text-success"> {item.event_status}</li> */}
                                          </ul>
                                        </h6>
                                      </div>
                                    </div>
                                  </div>
                                </a>
                              </div>
                            </div>
                          ))
                        ) : (
                          <div className="custom-container ">
                            <div className="empty-tab">
                              <h2>No Past Event Found!!</h2>
                              <h5 className="mt-3">
                                You have currently no events.
                              </h5>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </section>
              ) : (
                <div className="custom-container mt-5">
                  <div className="empty-tab">
                    <h3 className="mt-5">Have eatbids account?</h3>
                    <a
                      onClick={redLogin}
                      className="btn theme-btn w-100 mt-4"
                      role="button"
                    >
                      Log in
                    </a>
                  </div>
                  <div class="division">
                    <span>OR</span>
                  </div>
                  <div className="empty-tab">
                    <p className="btn gray-btn mt-3 text-3 w-100">
                      {" "}
                      You don't have an account?{" "}
                      <a href="/register/" className="text-black">
                        Sign up
                      </a>
                    </p>
                  </div>
                </div>
              )}
            </Tab>
          </Tabs>
        </div>
      </div>
    </Page>
  );
};

export default TabBid;
